import type { DiscountAppliedTo } from '@/features/campaigns/domain/enums/DiscountAppliedTo'
import type { DeliveryDiscountType } from '@/features/deliveryDiscount/domain/enums/DeliveryDiscountType'
import type { DiscountType } from '@/features/discountOffer/domain/enums/DiscountType'

export class OrderDiscountEntity {
  campaign?: OrderDiscountCampaignAdminEntity
  coupon?: OrderDiscountCouponAdminEntity
  deliveryDiscount?: OrderDiscountBranchDeliveryDiscountEntity
  createdAt?: string
}

export class OrderDiscountCampaignAdminEntity {
  campaignId?: number
  campaignName?: string | null
  steps?: Array<OrderDiscountCampaignStepAdminEntity> | null
  itemDiscountedAmount?: number
  deliveryFeeDiscountedAmount?: number
  serviceShareAmount?: number
  branchShareAmount?: number
}

export type OrderDiscountCampaignStepAdminEntity = {
  index?: number
  type?: DiscountType
  value?: number
  maxDiscountAllowed?: number
  appliedTo?: DiscountAppliedTo
  minCartAmount?: number | null
}

export class OrderDiscountCouponAdminEntity {
  id?: string
  couponId?: number
  couponName?: string | null
  onItem?: OrderDiscountCouponOnItemEntity
  onDelivery?: OrderDiscountCouponOnDeliveryEntity
  itemDiscountedAmount?: number
  deliveryFeeDiscountedAmount?: number
  minCartAmount?: number
}

export type OrderDiscountCouponOnItemEntity = {
  discountType?: DiscountType
  discountValue?: number
  maxDiscountAllowedAmount?: number
  serviceShareAmount: number
  branchShareAmount: number
}
export type OrderDiscountCouponOnDeliveryEntity = {
  discountType?: DiscountType
  discountValue?: number
  maxDiscountAllowedAmount?: number
  serviceShareAmount: number
  branchShareAmount: number
}

export type OrderDiscountBranchDeliveryDiscountEntity = {
  deliveryDiscountId?: string
  type?: DeliveryDiscountType
  segments?: Array<{
    id?: string
    from?: number
    to?: number
    discountValue?: number
    discountType?: DiscountType
    serviceRatio?: number | null
    branchRatio?: number | null
    limitedBranchShareAmount?: number | null
  }> | null
  deliveryFeeDiscountedAmount?: number
  serviceShareAmount?: number
  branchShareAmount?: number
}
